import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-login-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, "老玩客運動", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "content-subtitle" }, "輸入您的帳號及密碼進行登入", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 登入 ")
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, {
      class: "login-content",
      type: "flex",
      gutter: [24,24],
      justify: "space-around",
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          span: 24,
          md: 12,
          lg: {span: 12, offset: 0},
          xl: {span: 6, offset: 2}
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _createVNode(_component_a_form, {
              model: _ctx.formState,
              layout: "vertical",
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "帳號",
                  name: "identifier",
                  rules: [{ required: true, message: '請輸入您的帳號' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.identifier,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.identifier) = $event)),
                      disabled: _ctx.submitting,
                      size: "large"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "密碼",
                  name: "credential",
                  rules: [{ required: true, message: '請輸入您的密碼' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: _ctx.formState.credential,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.credential) = $event)),
                      disabled: _ctx.submitting,
                      size: "large"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "身份",
                  name: "role"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      ref: "select",
                      value: _ctx.formState.role,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.role) = $event)),
                      options: _ctx.roleOptions,
                      disabled: _ctx.submitting,
                      size: "large",
                      style: _normalizeStyle({ width: _ctx.device.mobile ? '100%' : '150px' })
                    }, null, 8, ["value", "options", "disabled", "style"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { style: { marginTop: '40px' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      onClick: _ctx.login,
                      loading: _ctx.submitting,
                      type: "primary",
                      "html-type": "submit",
                      size: "large",
                      style: { width: '100%' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }),
        (!_ctx.device.mobile)
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 0,
              span: 24,
              md: 12,
              lg: 12,
              xl: 12,
              align: "center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('/src/assets/logo/logo.svg'),
                  alt: "logo-img",
                  style: { width: '80%' }
                }, null, 8, _hoisted_5)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}